import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Draw-proposal confirmation (for the initiating player). Once sent, the turn
 * timer is paused until the other player responds (see ArenaBattle::proposeDraw).
 */
export default class ProposeDrawConfirmModal extends Modal {
  loading = false;
  className() {
    return 'ArenaProposeDrawModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-handshake"
    }), " ", app.translator.trans('forumaker-arena.forum.propose_draw.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaProposeDrawModal-text"
    }, app.translator.trans('forumaker-arena.forum.propose_draw.confirm_text')), m("div", {
      className: "ArenaProposeDrawModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-handshake",
      loading: this.loading,
      onclick: () => this.propose()
    }, app.translator.trans('forumaker-arena.forum.propose_draw.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.propose_draw.cancel_btn'))));
  }
  async propose() {
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/arena/battles/${this.attrs.battle.id()}/propose-draw`,
        errorHandler: () => {} // see ArenaProfilePage.tsx saveDeck()
      });
      this.hide();
      this.attrs.onProposed?.();
    } catch {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.propose_draw.error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ProposeDrawConfirmModal', ProposeDrawConfirmModal);